// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2NQWq","list":"BalanceDue_list__3Ye3M","listRow":"BalanceDue_listRow__VqW55","total":"BalanceDue_total__12hJf"};